export default String.raw`
.promoBanner2 {
    color: $bannerTimerFontColor;

    a {
        color: inherit;
        text-decoration: none;

        .promoBanner2 {
            &__item {
                outline-offset: -2px !important;
            }
        }
    }
    
    &__wrapper > &__item:not(:first-child) {
        display: none !important;
    }

    &__wrapper {

        picture {
            img {
                width: 100%;
                aspect-ratio: auto;
                height: auto;
            }

            .lazy {
                position: relative;
                display: block;
                background-repeat: no-repeat;
                background-position: center center;

                img {
                    transition: opacity 0.3s ease-in-out;
                }
            }
        }
    }

    &__item {
        display: grid !important;
        grid-template-columns: repeat(10, 1fr);
        grid-template-rows: repeat(10, auto);
        width: 100%;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        align-content: center;
        justify-items: center;
    }

    &__placeholder {
        position: relative;
    }

    &__label {
        position: absolute;
        font-size: clamp(24px, 3.57vw, 30px);
        color: #6c6c6c;
        text-align: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: 0;

        &::after {
            content: 'Desktop';
        }
    }

    &__image {
        grid-area: 1 / 1 / 11 / 11;

        img {
            max-width: 100%;
            height: auto;
        }

        &--placeholder {
            object-fit: contain;
            min-height: 170px;
            max-width: 100%;
            width: 100%;
            object-position: 50% 50%;
            background-color: #f2f2f2;
            height: auto;
            max-height: 680px;
        }

    }

    &__text {
        font-size: clamp(24px, 2.38vw, 40px);
        font-weight: 600;
        line-height: clamp(32px, 3.33vw, 48px);
        text-align: center;
        margin: 0;
        height: max-content;
        width: 100%;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
        overflow: hidden;
        z-index: 1;

        &--position {
            grid-area: 3 / 1 / 5 / 6;
        }
    }

    .timer {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        z-index: 1;
        transition: visibility 0s, opacity 0.5s ease-in;

        &__heading {
            font-size: clamp(14px, 1.11vw, 24px);
            font-weight: 400;
            line-height: clamp(20px, 1.95vw, 28px);
            text-align: center;
            margin: 0;
        }

        &--position {
            grid-area: 6 / 1 / 8 / 6;
        }

        .countdown {
            display: grid;
            grid-template-columns: repeat(7, auto);
            grid-template-areas: "a b c d e f g" "h . i . j . k";
            text-align: center;
            width: fit-content;
            gap: 0 16px;
            justify-items: center;

            &__time-unit {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: $bannerTimerBgColor;
                color: $bannerTimerNumbersColor;
                width: clamp(48px, 5vw, 80px);
                height: clamp(48px, 5vw, 80px);
                font-size: clamp(24px, 2.22vw, 40px);
                aspect-ratio: 1;
                font-weight: 600;
                line-height: 40px;
                border: 3px solid $bannerTimerBorderColor;
                border-radius: 8px;

                &--days {
                    grid-area: a;
                }

                &--hours {
                    grid-area: c;
                }

                &--minutes {
                    grid-area: e;
                }

                &--seconds {
                    grid-area: g;
                }
            }

            &__separator {
                font-size: clamp(24px, 3vw, 44px);
                font-weight: 700;
                display: flex;
                justify-content: center;
                align-items: center;

                &:nth-of-type(1) {
                    grid-area: b;
                }

                &:nth-of-type(2) {
                    grid-area: d;
                }

                &:nth-of-type(3) {
                    grid-area: f;
                }
            }

            &__label {
                width: 100%;
                height: -moz-fit-content;
                height: fit-content;
                color: $bannerTimerFontColor;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;

                &--days {
                    grid-area: h;
                }

                &--hours {
                    grid-area: i;
                }

                &--minutes {
                    grid-area: j;
                }

                &--seconds {
                    grid-area: k;
                }
            }

            &--no-days {
                grid-template-columns: repeat(5, auto);
                grid-template-areas: "c d e f g" "i . j . k";
            }
        }
    }
}
`